


export class ExpertiseArea {
    Id: string;
    Area: string;
    Expertise: string;
}